import '../MiddleSide/Middle.css';

import {
  useEffect,
  useState,
} from 'react';

import Homepage from '../Home/Homepage';
import InputPost from '../Post/InputPost';

const Middle = ({ handleSubmit,
  body,
  setBody,
  setImportFile,
  posts,
  setPosts,
  search,
  images,
  setImages,
  handleImageChange,
  emptImg,
  setEmptImg,
  setFriendsProfile
}) => {


  const [searchResults, setSearchResults] = useState("")

  useEffect(() => {
    console.log("Middle", posts);
    if (posts && posts.results && posts.results.length > 0) {
      const searchData = posts.results.filter((val) => (
        val.title && val.title.toLowerCase().includes(search.toLowerCase()) ||
        val.content && val.content.toLowerCase().includes(search.toLowerCase())
      ));
      setSearchResults(searchData);
    }
  }, [posts, search]);

  return (
    <div className='M-features'>
      <InputPost
        handleSubmit={handleSubmit}
        body={body}
        setBody={setBody}
        setImportFile={setImportFile}
        images={images}
        handleImageChange={handleImageChange}
        emptImg={emptImg}
        setEmptImg={setEmptImg}
        setImages={setImages}
      />

      <Homepage
        posts={searchResults}
        setPosts={setPosts}
        setFriendsProfile={setFriendsProfile}
        images={images}
      />
    </div>
  )
}

export default Middle